export const AppointmentSvg = (props: any) => {
  return (
    <svg
      {...props}
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.333496 20.1666C0.333496 22.15 1.85016 23.6666 3.8335 23.6666H20.1668C22.1502 23.6666 23.6668 22.15 23.6668 20.1666V10.8333H0.333496V20.1666ZM20.1668 2.66665H17.8335V1.49998C17.8335 0.79998 17.3668 0.333313 16.6668 0.333313C15.9668 0.333313 15.5002 0.79998 15.5002 1.49998V2.66665H8.50017V1.49998C8.50017 0.79998 8.0335 0.333313 7.3335 0.333313C6.6335 0.333313 6.16683 0.79998 6.16683 1.49998V2.66665H3.8335C1.85016 2.66665 0.333496 4.18331 0.333496 6.16665V8.49998H23.6668V6.16665C23.6668 4.18331 22.1502 2.66665 20.1668 2.66665Z"
        fill={props?.fill ?? '#3E4685'}
      />
    </svg>
  )
}
